// A partner's colour, as a dot. Decoration beside the name, never instead of
// it: colour carries no meaning a reader could be expected to know, and a
// partner with no colour simply has no dot.

import type { ReactNode } from "react";
import styles from "./PartnerSwatch.module.css";

export interface PartnerSwatchProps {
  /** `#rrggbb`, or null for a partner nobody has coloured. */
  color: string | null;
}

export function PartnerSwatch({ color }: PartnerSwatchProps): ReactNode {
  if (color === null) return null;
  return <span className={styles.swatch} style={{ background: color }} aria-hidden="true" />;
}
